/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Active/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Active({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/PracticeHubAccountStatus/Active"
  
}) {
let constantData = 'Has access with'
let patientPersonPublicUserAccountEmailValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'person.public_user.account.email',
})
let aggregateData = fromAggregate.join(constantData, patientPersonPublicUserAccountEmailValueData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'Has access with'"
 data="patient.person.public_user.account.email"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}